<nav class="navbar toggle-color navbar-expand-lg navbar-dark fixed-top z-index-999">
  <div class="logo pointer d-inline-block" *ngIf="deviceType == 'browser'"
    [ngClass]="{'logo-bg':router.url.includes('/userhome')}" (click)="goToRespectiveScreen('home')"><img
      [src]="clientDetails?.header_logo">
  </div>
  <div class="logo pointer d-inline-block" *ngIf="deviceType != 'browser'" (click)="gotoChannel()"
    [ngClass]="{'logo-bg':router.url.includes('/userhome')}">
    <img src="{{imagedata}}">

  </div>
  <div class="w-140p">
    <div class="pt-0  d-inline-block d-md-none d-sm-none " fxShow.xs="true">
      <app-google-translate></app-google-translate>
    </div>
  </div>
  <span class="pt-0  d-inline-block d-md-none d-sm-none" fxShow.xs="true"><a (click)="gotoCreator()"
      routerLinkActive="active" class="mr-2 ml-2 pointer">CREATORS</a></span>
  <div *ngIf="!loggedIn && !userIdParam" fxShow.xs="true" fxHide class="fa fa-user" (click)="redirectTo('signin')">
  </div>
  <h2 class="expo-name" *ngIf="router.url.includes('expo/expo-details')">
    <a role="button" class="back-button" (click)="goBack()"><i class="fa fa-chevron-circle-left pr-10"
        aria-hidden="true"></i></a>
    {{expoInfo?.name}}
  </h2>
  <div class="w-140p ">
    <div class="fs-16 pointer mr-10 mobile-active hoverchange hoverchange"
      *ngIf="userInfo?.id && router.url.includes('userhome') || router.url.includes('mylist')"
      [ngClass]="{'element-active':router.url.includes('mylist') }" routerLink='/mylist'>My List
    </div>
    <button fxShow.xs="true" fxHide id="arevea_mobile_nav" class="profile-pic notranslate p-0"
      (click)="rightsidenav.toggle()"
      *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')">
      {{displayName
      |uppercase}}
    </button>
    <div fxShow.xs="true" fxHide id="sideNav_mobile" class="artist-pic m-0 text-center pointer"
      (click)="rightsidenav.toggle()"
      *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
      [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
  </div>
  <div class="navbar-collapse align-content" id="navbarSupportedContent">
    <ul class="navbar-nav pointer pr-0" [ngClass]="{'logo-bg':router.url.includes('/userhome')}" *ngIf="!userIdParam">
      <!-- <li><a class="signin"><img src="assets/website/homepage/search-icon.svg"></a></li> -->
      <span fxShow fxHide.xs="true" class="pr-10 pt-7"><a (click)="gotoCommunities()" routerLinkActive="active"
        class="mr-2 ml-2 pointer">Communities</a></span>
      <div class="dropdown mr-20 mt-0 pt-7 marketplace d-none d-md-inline-block">
        <a class=" dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          Marketplace
        </a>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" routerLink="/network-market/market" routerLinkActive="bg-active">Merchandise</a>
          <a class="dropdown-item" routerLink="/network-market/event" routerLinkActive="bg-active">Events</a>
          <a class="dropdown-item" routerLinkActive="bg-active"
            *ngIf="isCryptoWallet == 1 && loggedIn" (click)="checkAndNavigateToNFT()">NFT</a>
        </div>
      </div>
      <div class="pt-0 pr-20" [ngClass]="{'pt-5':!loggedIn}" fxShow fxHide.xs="true">
        <app-google-translate></app-google-translate>
      </div>
      <span *ngIf="!loggedIn" class="pt-1 pr-10 m-auto" fxhide.xs="true" fxshow="">
        <a (click)="gotoCreator()" class="mr-2 ml-2 pointer" routerlinkactive="active">CREATORS</a>
    </span>
    <li *ngIf="!loggedIn" fxShow fxHide.xs="true">
        <button mat-flat-button class="flat-primary-button tertiary-bg-button"
            (click)="redirectTo('signin')">Sign
            In / Up</button>
    </li>
    <div class="ptb-5 plr-20 pt-7 pointer mr-10 m-d-none text-center hoverchange"
        *ngIf="userInfo?.id && loggedIn && (router.url.includes('userhome') || router.url.includes('mylist') || router.url.includes('communities'))"
        [ngClass]="{ 'element-active': router.url.includes('mylist') }" routerLink="/mylist">
        My List
    </div>

      <div fxShow fxHide.xs="true" id="arevea_mobile_nav" class="artist-pic m-0 text-center pointer"
        (click)="rightsidenav.toggle()"
        *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
        [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
      <button fxShow fxHide.xs="true" id="side_nav_mobile" class="profile-pic notranslate mr-10"
        (click)="rightsidenav.toggle()"
        *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')">
        {{displayName
        |uppercase}} </button>
      <mat-sidenav-container id="arevea_sideNav" class="Top-bar rightsidenav-parent">
        <mat-sidenav #rightsidenav mode="push" class="fs-16 text-center" position="end">
          <mat-icon class="close_button mr-2 mt-1" (click)="rightsidenav.close()">close
          </mat-icon>
          <div class="row mt-30">
            <div class="col-md-3  col-xs-3 pl-40">
              <div id="arevea_sideNav" class="profile-pic notranslate m-0"
                *ngIf="!userInfo?.is_guest && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
              <button id="arevea_sideNav" class="profile-pic notranslate f-l bg-yp-0"
                *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo.profile_pic =='')">
                {{displayName |uppercase}}
              </button>
            </div>
            <div class="col-md-9 col-xs-9">
              <div class="f-l mt-6">
                <span *ngIf="profileName.length <= 16" class="pointer">{{profileName}}
                </span>
                <span *ngIf="profileName.length > 16" matTooltipPosition="above" matTooltip="{{profileName}}"
                  class="pointer">
                  {{profileName | slice: 0:16}}
                  {{profileName.length > 16 ? "..." : ""}}
                </span>
              </div>
              <div class="c-g">
                <button class="fs-14 mb-20 mt-10 mr-80 logout_box" (click)="signout()" mat-button>SIGN
                  OUT</button>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-6 text-center" *ngIf="isCryptoWallet==1">
                <p class="cryptoName mb-1">
                    Crypto Wallet
                </p>
                <button mat-flat-button class="cryptoButton button1"
                    [ngClass]="{'cursor-default': walletID}">
                    <span *ngIf="walletID== undefined || walletID == '' || walletID == null"
                        (click)="connectToWallet()">Connect</span>
                    <span *ngIf="walletID" matTooltip="{{available_balance}}"><img src="{{cryptoSymbol}}"
                            width="16" class="mb-1"> {{ crypto_balance }}</span>
                </button>
            </div>
            <div *ngIf="isCryptoWallet==1" class="col-6 text-center">
                <p class="cryptoName mb-1">
                    Cash Wallet
                </p>
                <button mat-flat-button class="cryptoButton custom-red-button"
                    routerLinkActive="router-link-active" [routerLink]="cashWalletLink">
                    <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount
                        |currency:walletInfo?.currency}}</span>
                    <span *ngIf="walletInfo?.amount == null ">{{0.00
                        | currency:getCurrency}}</span>
                </button>
            </div>

            <div *ngIf="isCryptoWallet==0" class="col-12 text-center pb-2">
                <p class="cryptoName mb-1">
                    Cash Wallet
                </p>
                <button mat-flat-button class="cryptoButton custom-red-button"
                    routerLinkActive="router-link-active" [routerLink]="cashWalletLink">
                    <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount
                        |currency:walletInfo?.currency}}</span>
                    <span *ngIf="walletInfo?.amount == null ">{{0.00
                        | currency:getCurrency}}</span>
                </button>
            </div>
        </div>
        
        <div class="line mt-1"></div>
          <div class="text-left lh-42 mt-5">
            <div class="pl-20 fw-600" *ngIf="channelUrl=='channel'" fxShow.sm="true" fxHide="true">Channel
              Menu</div>
            <div *ngFor="let list of userList" fxShow.sm="true" fxHide="true">
              <div class="pointer pl-20" *ngIf="channelUrl=='channel'" [ngClass]="{
                                    'active-menu': list.activeMenu,
                                    'mb-5': list.activeMenu
                                  }" (click)="goToUser(list.link,list)">
                <div class="ml-5 " *ngIf="!list.hide">{{ list.name }}</div>
              </div>
            </div>
            <div class="pl-20 fw-600" *ngIf="channelUrl=='channel'" fxShow.sm="true" fxHide="true">User
              Dashboard
            </div>
            <div *ngFor="let list of menuList">
              <div class="pointer pl-20" *ngIf="list.sub_menu && list.sub_menu.length == 0 && list.dualapp" [ngClass]="{
                                    'active-menu': list.activeMenu,'bg-primary':list.activeMenu,
                                    'mb-5': list.activeMenu
                                  }" (click)="goToMenu(list.link,list)">
                <div class="ml-5 " *ngIf="!list.hide ">{{ list.name }}</div>
              </div>

              <span class="menu-name" *ngIf="list.sub_menu && list.sub_menu.length > 0">
                <mat-expansion-panel [expanded]="list.activeMenuList" (opened)="list.activeMenuList"
                  (closed)="!list.activeMenuList" [ngClass]="{
                      'active-menu': list.activeMenuList,
                      'mb-5': list.activeMenuList
                    }" (click)="goToMenu(list.link, list)">
                  <mat-expansion-panel-header [ngClass]="{'bg-primary':list.activeMenuList}">
                    <mat-panel-title>
                      <div class="menu-padding pointer pr-3">
                        <span class="menu-name ml-txt">{{ list.name }}</span>
                        <i class="fa fa-angle-right ml-35" *ngIf="!list.activeMenuList"></i>
                        <i class="fa fa-angle-down ml-35" *ngIf="list.activeMenuList"></i>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div fxLayout="column" class="pt-10">
                    <div class=" menu-name ml-45 pointer" *ngFor="let menu of list.sub_menu" [ngClass]="{
                          'active-type': menu.subMenuActive}">
                      <div (click)="navigateSubmenu(menu.link)" *ngIf="menu.dualapp">{{menu.menu_name}} {{deviceInfo}}
                      </div>

                    </div>
                  </div>
                </mat-expansion-panel>
              </span>

            </div>
          </div>

        </mat-sidenav>
      </mat-sidenav-container>
    </ul>
  </div>
  <!-- <div class="col-9 col-md-4 col-lg-6  text-right">
      <div class="d-inline-block gt-bg logo-bg">-->

  <ng-container *ngIf="isNetworkNotification">
    <div class="app-notification">
      <div class="position-ab-notification">
        <div class="row no-gutters title-cls">
          <div class="col-11">
            <p class="fs-15 mb-0">{{message}}</p>
          </div>
          <div class="col-1 text-right pointer" (click)=closeBox()>
            <i class="fa fa-times-circle" aria-hidden="true"></i>
          </div>
        </div>
        <div class="row no-gutters p-3">
          <div class="col-12 text-center">
            <button class="join-nt-btn pt-5" (click)="joinUrl()">JOIN</button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</nav>
<router-outlet></router-outlet>
<footer class="app-footer black-bg-color app-website fw-500">
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-3 col-lg-4 mb-2">
        <img [src]="clientDetails.header_logo" width="100" class="mb-3 ">
        <div class="g-txt mb-3">&copy; {{copyRightYear}} {{clientDetails.name}} Inc. All rights reserved.</div>
        <ng-container class="d-inline">
          <a class="mr-2" href="https://play.google.com/store/apps/details?id=com.arevea.tv" target="_blank"><img
              [src]="assets_url + 'website/homepage/googleplay.png'" width="130px"></a>
          <a href="https://apps.apple.com/in/app/arevea/id1535047464" target="_blank"><img
              [src]="assets_url + 'website/homepage/appstore.png'" width="130px" class=""></a>
        </ng-container>
      </div>
      <div class="col-6 col-md-2 col-lg-2 mb-2">
        <p class="text-info">Company</p>
        <div class="pointer contactusb"> <a class="text-decoration" routerLink="/contactus">Contact Us</a></div>

      </div>
      <div class="col-6 col-md-3 col-lg-2 mb-2 pl-0">
        <p class="text-info">Legal</p>
        <div class="pointer d-inline">
          <a (click)="goToRespectiveScreen('privacypolicy')">Privacy Policy</a><br>
          <a (click)="goToRespectiveScreen('cookiepolicy')">Cookie Policy</a><br>
          <a (click)="goToRespectiveScreen('termsandconditions')">Terms of Service</a>
        </div>
      </div>
      <div class="col-6 col-md-2 col-lg-2">
        <p class="text-info">Follow us</p>
        <div class="pointer" *ngIf="clientDetails?.socialIcons == 1">
          <a href="{{clientDetails.instagram}}" target="_blank"> <span class="m-icon"><img
              src='{{assets_url + "clients/manaqi/manaqi_icons/insta.png"}}' width="20px"></span></a>
          <a href="{{clientDetails.facebook}}" target="_blank">
              <span class="m-icon ml-0"><img src='{{assets_url + "clients/manaqi/manaqi_icons/fb.png"}}'
                      width="20px"></span></a>
                      <a href="{{clientDetails.twitter}}" target="_blank"> <span class="m-icon"><img
                          src='{{assets_url + "clients/manaqi/manaqi_icons/twitter.png"}}'
                          width="20px"></span></a>
          <a href="{{clientDetails.linkedin}}" target="_blank"> <span class="m-icon"><img
                      src='{{assets_url + "clients/manaqi/manaqi_icons/linkedin.png"}}'
                      width="20px"></span></a>
          


      </div>
        <!-- <div class="pointer"  [hidden]="clientDetails?.socialIcons == 1">
          <a href="https://www.facebook.com/Areveatv-111754950520279/" target="_blank">
            <app-svg [icon]="'homepage-facebook'"></app-svg>
          </a>
        </div> -->
        <div class="pointer" [hidden]="clientDetails?.socialIcons == 1">
          <a href="https://www.linkedin.com/company/bigbee-ai/" target="_blank">
            <i class="fa fa-linkedin fs-20" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      <div class="col-6 col-md-2 col-lg-2 pointer"  [hidden]="clientDetails?.socialIcons == 1">
        <!-- <img [src]="assets_url + 'Powered by- Arevea.svg'" width="100" class="mb-3" (click)="redirectTo('/')"> -->
        <span class="mb-3" *ngIf="clientDetails?.slug != 'bigbeeai'" (click)="redirectTo('/')">
          <app-svg [icon]="'powered-by-bigbee'"></app-svg>
        </span>
      </div>
    </div>
  </div>
</footer>